import styled from 'styled-components';
import { Button, Typography } from '@web-chat-core/ui-kit';

export const OnboardingWrapper = styled.div`
    box-sizing: border-box;
    padding: 16px;
    color: ${props => props.theme.root.colors.basicColors.white['100%']};
`;

export const OnboardingBtn = styled(Button)`
    display: block;
    margin-left: auto;
    color: ${({ theme }) => theme.root.colors.basicColors.black['80%']};
    font-weight: 500;
    letter-spacing: 0.25px;
`;

export const OnboardingTitle = styled(Typography)`
    display: block;
    margin: 0 0 8px 0;
`;
